<template>
    <form>
        <div class="row">
            <div class="small-12 columns" :class="{ error: showCountDepotHolderErrorText }">
                <label>
                    Anzahl der Depotinhaber
                    <input type="number" v-model="formData.countDepotHolder"/>
                </label>
                <small class="error" v-if="showCountDepotHolderErrorText">
                    {{ countDepotHolderErrorText }}
                </small>
            </div>
            <div class="small-12 columns object-value-input-container" :class="{ error: showObjectValueErrorText }">
                <label>
                    Gegenstandswert
                    <currency-input
                        class="object-value-input"
                        v-model="formData.objectValue"
                        :options="viewData.currencyInputOptions"
                    />
                </label>
                <small class="error" v-if="showObjectValueErrorText">
                    {{ objectValueErrorText }}
                </small>
            </div>
            <div @click.stop.prevent class="hint small-12 columns">
                <i>(Wie ermittle ich den Gegenstandswert?)
                    <span class="hint-text panel">
                        Der Gegenstandswert entspricht dem aus dem Erwerb von Wirecard-Wertpapieren im Zeitraum vom 04.04.2015 bis 18.06.2020,
                        10:43 Uhr erlittenen Schaden, d.h. Kaufpreis abzüglich Verkaufspreis.
                        Sofern sich noch Papiere im Depot befinden, ist statt dem Verkaufspreis der aktuelle Tageskurs in Abzug zu bringen.
                    </span>
                </i>
            </div>
        </div>
    </form>
</template>

<script>
import CurrencyInput from './CurrencyInput';
import TypeHelper from '../helper/TypeHelper';
import Validation from '../helper/Validation';

export default {
    name: 'CostCalculatorForm',
    components: { CurrencyInput },
    data: () => ({
        formData: {
            countDepotHolder: null,
            objectValue: null
        },
        validation: {
            isFormDirty: false,
            isCountDepotHolderDirty: false,
            isObjectValueDirty: false
        },
        viewData: {
            currencyInputOptions: {
                "currency": "EUR",
                "currencyDisplay": "symbol",
                "valueRange": {
                    "min": 0
                },
                "hideCurrencySymbolOnFocus": true,
                "hideGroupingSeparatorOnFocus": true,
                "hideNegligibleDecimalDigitsOnFocus": true,
                "autoDecimalDigits": false,
                "autoSign": true,
                "useGrouping": true,
                "accountingSign": false
            }
        }
    }),
    computed: {
        showCountDepotHolderErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isCountDepotHolderDirty)
                    && TypeHelper.isNotNullOrUndefined(this.countDepotHolderErrorText);
        },
        showObjectValueErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isObjectValueDirty)
                    && TypeHelper.isNotNullOrUndefined(this.objectValueErrorText);
        },
        countDepotHolderErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.countDepotHolder, validators);
        },
        objectValueErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.objectValue, validators);
        },
    },
    methods: {
        validateForm()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        isFormValid()
        {
            let isValid = this.countDepotHolderErrorText === null;
            isValid = isValid && (this.objectValueErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeFormData', this.formData);
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        }
    },
    watch: {
        'formData.countDepotHolder': function()
        {
            this.validation.isCountDepotHolderDirty = true;
        },
        'formData.objectValue': function()
        {
            this.validation.isObjectValueDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        }
    }
};
</script>

<style scoped>
    .hint {
        position: relative;
        display: inline-block;
        width: 100%;
        margin-bottom: 10px;
        color: black!important;
        font-size: 0.875rem;
    }

    .hint i {
        color: #4d4d4d;
        border-bottom: 1px solid black;
        cursor: pointer;
    }

    .hint .hint-text {
        visibility: hidden;
        text-align: center;
        padding: 10px;
        border-radius: 6px;
        margin-top: 5px;
        font-style: normal;

        position: absolute;
        z-index: 10000;
        width: 100%;
        top: 100%;
        left: 0;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    .hint i:hover .hint-text {
        visibility: visible;
    }

    .hint i:active .hint-text {
        visibility: visible;
    }

    .hint .hint-text::after {
        content: " ";
        position: absolute;
        bottom: 100%;
        left: 5%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent rgb(0 0 0 / 20%) transparent;
        color: #4f4f4f;
    }

    .object-value-input {
        margin-bottom: 2px;
    }

    .object-value-input.error {
        margin-bottom: 0px!important;
    }

    .object-value-input-container .error {
        margin-bottom: 2px;
    }

    .error label {
        color: #4d4d4d;
    }

    select {
        margin: 0 0 1rem;
    }

    .error select {
        margin-bottom: 0;
    }
</style>
